import React from "react";
import ShopIndex from "../ShopIndex";
import { Navigate, Route, Routes, useNavigation } from "react-router-dom";
import Category from "../Category/Index";
import Dashboard from "../dashboard/Dashboard";
import Shop from "../Shop/ShopIndex";
import ProductIndex from "../Products/ProductIndex";
import SupplierIndex from "../Suppliers/SupplierIndex";
import CustomerIndex from "../Customers/CustomerIndex";
import StockIndex from "../Stock/StockIndex";
import PurchaseIndex from "../Purchase/PurchaseIndex";
import UnitsIndex from "../Units/UnitsIndex";
import CurrencyIndex from "../Currencies/CurrencyIndex";
import ExchangeRateIndex from "../ExchangeRates/ExchangeRateIndex";
import AccountIndex from "../Accounts/AccountIndex";
import AccountTransactionIndex from "../AccountTransactions/AccountTransactionIndex";
import AccountTransferIndex from "../AccountTransfers/AccountTransferIndex";
import SalesIndex from "../Sales/SalesIndex";
import SalePaymentIndex from "../SalesPayments/SalePaymentsIndex";
import EmployeeIndex from "../Employee/EmployeeIndex";
import ExpenseIndex from "../Expense/ExpenseIndex";
import IncomeIndex from "../Income/IncomeIndex";
import ExpenseCategoryIndex from "../ExpenseCategory/ExpenseCategoryIndex";
import PayrollIndex from "../Payroll/PayrollIndex";
import PurchasePaymentIndex from "../PurchasePayments/PurchasePaymentIndex";
import Login from "../../web/components/user/Login";
import { useAuth } from "../../context/AuthContext";
import SaleReturnIndex from "../saleReturn/saleReturnIndex";
import SaleReturnAdd from "../saleReturn/saleReturnAdd";
import PurchaseReturnIndex from "../purchaseReturn/PurchaseReturnIndex";
import PurchaseReturnAdd from "../purchaseReturn/PurchaseReturnAdd";
import PurchaseReturnEdit from "../purchaseReturn/PurchaseReturnEdit";
import AdvanceIndex from "../Advance/AdvanceIndex";
import ReportsIndex from "../reports/reportsIndex";
import Users from "../pages/users/Users";
import ProfileChangePassword from "../pages/users/ProfileChangePassword";
import { TenantProvider } from "../../context/TenantContext";
import MyShopOverview from "../tenant/MyShopOverview";
import MyShopEmployees from "../tenant/MyShopEmployees";
import RecycleBinIndex from "../RecycleBin/RecycleBinIndex";

const ShopRoutes = () => {
  const auth = useAuth();
  const token = auth?.user?.token;
  const user = auth?.user?.user;

  return (
    <Routes>
      <Route path="/" element={user ? <Navigate to="/shop/" /> : <Login />} />

      <Route
        path="/shop/*"
        element={
          user?.is_staff || user?.verified ? (
            <TenantProvider>
              <ShopIndex />
            </TenantProvider>
          ) : (
            <Navigate to="/" />
          )
        }
      >
        <Route path="dashboard/" element={<Dashboard />} />
        <Route path="shop/" element={<Shop />} />
        <Route path="my-shop/" element={<MyShopOverview />} />
        <Route path="my-shop/employees/" element={<MyShopEmployees />} />
        <Route path="users/" element={<Users />} />
        <Route path="profile/change-password/" element={<ProfileChangePassword />} />
        <Route path="category/" element={<Category />} />
        <Route path="units/" element={<UnitsIndex />} />
        <Route path="currencies/" element={<CurrencyIndex />} />
        <Route path="exchange-rates/" element={<ExchangeRateIndex />} />
        <Route path="accounts/" element={<AccountIndex />} />
        <Route path="account-transactions/" element={<AccountTransactionIndex />} />
        <Route path="account-transfers/" element={<AccountTransferIndex />} />
        <Route path="products/" element={<ProductIndex />} />
        <Route path="suppliers/" element={<SupplierIndex />} />
        <Route path="customers/" element={<CustomerIndex />} />
        <Route path="purchases/" element={<PurchaseIndex />} />
        <Route path="purchase-payments/" element={<PurchasePaymentIndex />} />
        <Route path="stock/" element={<StockIndex />} />
        <Route path="sales/" element={<SalesIndex />} />
        <Route path="sales-payments/" element={<SalePaymentIndex />} />
        <Route path="employees/" element={<EmployeeIndex />} />
        <Route path="expenses/" element={<ExpenseIndex />} />
        <Route path="incomes/" element={<IncomeIndex />} />
        <Route path="expense-categories/" element={<ExpenseCategoryIndex />} />
        <Route path="payroll/" element={<PayrollIndex />} />
        <Route path="advance/" element={<AdvanceIndex />} />
        <Route path="sale-return" element={<SaleReturnIndex />} />
        <Route path="sale-return-add" element={<SaleReturnAdd />} />
        <Route path="purchase-return" element={<PurchaseReturnIndex />} />
        <Route path="purchase-return-add" element={<PurchaseReturnAdd />} />
        <Route path="purchase-return/edit/:id" element={<PurchaseReturnEdit />} />
        <Route path="report-index" element={<ReportsIndex />} />
        <Route path="recycle-bin" element={<RecycleBinIndex />} />
      </Route>
    </Routes>
  );
};

export default ShopRoutes;
